import React from 'react';
import { useAuthenticatedContext, User } from '@ktag/commons';
import useAppState from '../../AppStore';

interface AuthenticatedUserRequiredProps {
  errorHandler?: ((isLoggedIn: boolean) => React.JSX.Element) | undefined;
  filter?: ((User: User) => boolean) | undefined;
  children: React.JSX.Element;
}

export const AuthenticatedUserRequired = ({
  errorHandler,
  filter,
  children,
}: AuthenticatedUserRequiredProps) => {
  const isLoggedIn = useAppState((state) => state.isLoggedIn);
  const user = useAuthenticatedContext();
  const displayComponent = isLoggedIn && user && (!filter || filter(user));
  if (displayComponent) {
    return children;
  }
  return errorHandler ? errorHandler(isLoggedIn) : null;
};
